import { Constants, isArray, ErrorConstants } from '../common/util';
import { TEMPLATE_PARSING_ISSUE } from '../model/common';
import { EvalService } from '../services/eval';
var DomParsing = /** @class */ (function () {
    function DomParsing() {
        this.evalService = new EvalService();
    }
    DomParsing.prototype.init = function (htmlResponse, model) {
        var meessages = [];
        if (htmlResponse && model) {
            //Remove comments from html
            htmlResponse = htmlResponse.replace(/<!--(?!>)[\S\s]*?-->/g, '');
            var domContent = void 0;
            try {
                DomParsing.templatesArray = {};
                domContent = new DOMParser().parseFromString(htmlResponse, 'text/html');
                this.domTraversal(domContent, model);
                this.parseNested(domContent, model, domContent);
                this.defaultChecked(domContent, model);
                this.defaultSelected(domContent, model);
                this.showDefaultButtons(domContent, model);
                this.deleteUnusedTags(domContent, model);
                this.setRequiredAttribute(domContent);
                var finalResponse = domContent.body.innerHTML.replace(new RegExp('{#model-', 'g'), 'model-');
                //  htmlResponse = eval('`' + finalResponse + '`');
                htmlResponse = this.evalService.parseTpl(finalResponse, model);
                htmlResponse = this.evalService.compileRsIfElse(htmlResponse);
                htmlResponse = this.evalService.rsUndefinedSafe(htmlResponse);
                return this.returnResponse(htmlResponse, meessages);
            }
            catch (error) {
                var meg = [error.message];
                return this.returnResponse('', meg);
            }
        }
        else {
            console.log('html string not found');
        }
        return this.returnResponse('', null);
    };
    // private parseTpl(template: any, data: any) {
    //     return template.replace(/\${([^{]+)}/g, (match: any) => {
    //         const path = match.substr(2, match.length - 3).trim();
    //        const kayArray = path?.trim().split(' ');
    //        let dataString =""
    //             kayArray.forEach((key:string) => {
    //                 // if(key.indexOf("model.")>-1){
    //                 //      dataString += this.getDescendantProp(data, key)
    //                 // }else{
    //                     dataString += key
    //                 // }
    //             });
    //         return dataString;
    //     });
    // }
    // private getDescendantProp(obj:any, desc:any) {
    //     const q = desc.replace(`${Constants.MODEL}.`, '');
    //     const key = q.split('[').join('.').split(']').join('').split('.');
    //     while (key.length) {
    //         obj = obj[key.shift()];
    //     }
    //     return obj;
    // }
    DomParsing.prototype.setRequiredAttribute = function (content) {
        var elements = content.querySelectorAll('[rsmonitor], [data-rsmonitor]');
        elements.forEach(function (element) {
            if (!element.getAttribute('required') || element.getAttribute('required') === 'false') {
                element.removeAttribute('required');
            }
        });
    };
    DomParsing.prototype.defaultSelected = function (content, model) {
        var _this = this;
        var selected = content.querySelectorAll("[" + Constants.SELECTED + "]");
        if (selected && selected.length) {
            selected.forEach(function (selectElement) {
                var attrValue = selectElement.getAttribute(Constants.SELECTED);
                var val = 'false';
                if (attrValue) {
                    val = _this.evalService.parseTpl(attrValue, model);
                }
                if (!val || val === 'false' || val === 'undefined' || val === 'null' || val.length === 0) {
                    selectElement.removeAttribute(Constants.SELECTED);
                }
                else {
                    selectElement.setAttribute(Constants.SELECTED, Constants.SELECTED);
                }
            });
        }
    };
    DomParsing.prototype.showDefaultButtons = function (content, model) {
        var _this = this;
        var elements = content.querySelectorAll("[" + Constants.RS_SHOW + "]");
        if (elements && elements.length) {
            elements.forEach(function (element) {
                var attrValue = element.getAttribute(Constants.RS_SHOW);
                var val = 'false';
                if (attrValue) {
                    val = _this.evalService.parseTpl(attrValue, model);
                }
                if (!val || val === 'false' || val === 'undefined' || val === 'null' || val.length === 0) {
                    element.setAttribute(Constants.DELETE_TAG, Constants.DELETE_TAG);
                }
                else {
                }
            });
        }
    };
    DomParsing.prototype.defaultChecked = function (content, model) {
        var _this = this;
        var checked = content.querySelectorAll("[" + Constants.CHECKED + "]");
        if (checked && checked.length) {
            checked.forEach(function (checkElement) {
                var attrValue = checkElement.getAttribute(Constants.CHECKED);
                var val = 'false';
                if (attrValue) {
                    val = _this.evalService.parseTpl(attrValue, model);
                }
                if (!val || val === 'false' || val === 'undefined' || val === 'null' || val.length === 0) {
                    checkElement.removeAttribute(Constants.CHECKED);
                }
                else {
                    checkElement.setAttribute(Constants.CHECKED, Constants.CHECKED);
                }
            });
        }
    };
    DomParsing.prototype.parseNested = function (domContent, model, template, isTemplateStr) {
        var _this = this;
        if (domContent && template) {
            var templateStr_1 = '';
            var nestedTemplateContainers = [];
            if (!isTemplateStr) {
                nestedTemplateContainers = domContent.querySelectorAll('[rsnestedtemplatedata], [data-rsnestedtemplatedata]');
            }
            else {
                nestedTemplateContainers.push(domContent);
            }
            nestedTemplateContainers.forEach(function (nestedTemplateContainer) {
                var _a;
                var rsTemplateClassName = nestedTemplateContainer.getAttribute('rstemplateclassname') ||
                    nestedTemplateContainer.getAttribute('data-rstemplateclassname');
                var rsDisplayFormReferenceKey = nestedTemplateContainer.getAttribute('rsdisplayformreferencekey') ||
                    nestedTemplateContainer.getAttribute('data-rsdisplayformreferencekey');
                var templateId = nestedTemplateContainer.getAttribute('rstempaltename') ||
                    nestedTemplateContainer.getAttribute('data-rstemplatename');
                if (template.querySelector('[rstempalteid =' + templateId + '], [data-rstempalteid =' + templateId + ']') &&
                    !isTemplateStr) {
                    templateStr_1 = (_a = template.querySelector('[rstempalteid =' + templateId + '], [data-rstempalteid =' + templateId + ']')) === null || _a === void 0 ? void 0 : _a.innerHTML;
                }
                else {
                    templateStr_1 = template.innerHTML;
                }
                templateStr_1 = templateStr_1.replace(new RegExp('{data-rstemplateclassname}', 'g'), rsTemplateClassName);
                templateStr_1 = templateStr_1.replace(new RegExp('{rsTemplateClassName}', 'g'), rsTemplateClassName);
                templateStr_1 = templateStr_1.replace(new RegExp('{data-rsDisplayFormReferenceKey}', 'g'), rsDisplayFormReferenceKey);
                templateStr_1 = templateStr_1.replace(new RegExp('{rsDisplayFormReferenceKey}', 'g'), rsDisplayFormReferenceKey);
                var nestedDataKey = nestedTemplateContainer.getAttribute('rsnestedtemplatedata') ||
                    nestedTemplateContainer.getAttribute('data-rsnestedtemplatedata');
                var modifyTemplate = templateStr_1.replace(new RegExp('{rsTemplateData}', 'g'), "" + nestedDataKey);
                if (isTemplateStr) {
                    modifyTemplate = templateStr_1.replace(new RegExp('rsTemplateInlineData', 'g'), '${' + Constants.MODEL + '.' + nestedDataKey + '}');
                }
                if (modifyTemplate) {
                    nestedTemplateContainer.innerHTML = modifyTemplate;
                    _this.domTraversal(nestedTemplateContainer, model);
                    var hasChildTemplateContainers = nestedTemplateContainer.querySelectorAll('[rsnestedtemplatedata], [data-rsnestedtemplatedata]');
                    if (hasChildTemplateContainers && hasChildTemplateContainers.length > 0) {
                        _this.parseNested(nestedTemplateContainer, model, template);
                    }
                }
            });
        }
    };
    DomParsing.prototype.domTraversal = function (domContent, model) {
        if (domContent) {
            var children = domContent.children;
            if (children.length) {
                for (var i = 0; i < children.length; i++) {
                    if (children[i].getAttribute(Constants.RS_SORT)) {
                        this.rsSortHandling(children[i], model);
                    }
                    else if (children[i].getAttribute(Constants.RS_OF)) {
                        this.rsOfHandling(children[i], model);
                    }
                    else if (children[i].getAttribute(Constants.RS_IF)) {
                        var responseHtml = this.rsIfHandling(children[i], model);
                        children[i].innerHTML = responseHtml;
                    }
                    else if (children[i].getAttribute(Constants.RS_FOR)) {
                        this.rsForHandling(children[i], model);
                    }
                    if (children[i].getAttribute(Constants.RS_DATA)) {
                        this.setRsData(children[i], model);
                    }
                    this.domTraversal(children[i], model);
                }
            }
        }
    };
    // private rsIfHandling(content: Element, model: any) {
    //   let responseHtmlString = '';
    //   let rsifElementAttribute = content.getAttribute(Constants.RS_IF);
    //   const ifStatement = rsifElementAttribute?.trim().split(' ');
    //   if (ifStatement && (ifStatement.length === 3 || ifStatement.length === 1)) {
    //     const keys = ifStatement[0].split('.');
    //     let controlType = undefined;
    //     if (ifStatement[0].includes(`${Constants.MODEL}`)) {
    //       controlType = this.getDataFromModel(ifStatement[0], model);
    //     } else {
    //       controlType = model[keys[keys.length - 1]];
    //     }
    //     let codition = false;
    //     if (ifStatement.length === 1) {
    //       codition = controlType ? true : false;
    //     } else {
    //       const val = this.evalService.parseTpl('${' + rsifElementAttribute + '}', model);
    //       codition = val ? JSON.parse(val) : false;
    //       //  codition = eval(`'${rsifElementAttribute}' ${ifStatement[1]} ${ifStatement[2]?.toLowerCase()}`);
    //     }
    //     // const codition = eval(`'${controlType}' ${ifStatement[1]} ${ifStatement[2]}`);
    //     if (!codition) {
    //       responseHtmlString = '';
    //     } else {
    //       responseHtmlString = content.innerHTML;
    //       let idKey = ifStatement[0].replace(/\./g, '-');
    //       if (ifStatement.length > 2) {
    //         let idKeyRight = ifStatement[2].replace(/\'/g, '');
    //         let groupName = idKey.replace('-' + keys[keys.length - 1], '');
    //         idKey = idKey + '-' + idKeyRight;
    //         groupName = groupName.replace(new RegExp('\\[', 'g'), '{').replace(new RegExp('\\]', 'g'), '}');
    //         let priviousGroupName = groupName.split('-').slice(0, -1).join('-').trim();
    //         // responseHtmlString = responseHtmlString.replace(new RegExp(`{#${priviousGroupName}`, 'g'), `{#${groupName}`);
    //         responseHtmlString = responseHtmlString.replace(`{#${priviousGroupName}`, `{#${groupName}`);
    //       } else {
    //         responseHtmlString = responseHtmlString.replace(new RegExp('{rsGroupName}', 'g'), `${ifStatement[0]}`);
    //       }
    //       responseHtmlString = responseHtmlString.replace(new RegExp('{rsId}', 'g'), idKey);
    //     }
    //   } else {
    //     responseHtmlString = ErrorConstants.RSIF_SYNTAXT_ERROR;
    //     throw Error(ErrorConstants.RSIF_SYNTAXT_ERROR);
    //   }
    //   if (responseHtmlString) {
    //     // responseHtmlString = responseHtmlString.replace(new RegExp('{rsId}', 'g'), ('rsdk-' + window.performance.now()).replace(".", ""));
    //   } else {
    //     content.setAttribute(Constants.DELETE_TAG, Constants.DELETE_TAG);
    //   }
    //   content.removeAttribute(Constants.RS_IF);
    //   return responseHtmlString;
    // }
    DomParsing.prototype.rsIfHandling = function (content, model) {
        var responseHtmlString = '';
        var rsifElementAttribute = content.getAttribute(Constants.RS_IF);
        var ifStatement = rsifElementAttribute === null || rsifElementAttribute === void 0 ? void 0 : rsifElementAttribute.trim().split(' ');
        if (rsifElementAttribute) {
            var codition = false;
            var val = this.evalService.parseTpl('${' + rsifElementAttribute + '}', model);
            if (!val || val === 'false' || val === 'undefined' || val === 'null' || val.length === 0) {
                responseHtmlString = '';
            }
            else {
                responseHtmlString = content.innerHTML;
            }
        }
        else {
            responseHtmlString = ErrorConstants.RSIF_SYNTAXT_ERROR;
            throw Error(ErrorConstants.RSIF_SYNTAXT_ERROR);
        }
        if (responseHtmlString) {
            // responseHtmlString = responseHtmlString.replace(new RegExp('{rsId}', 'g'), ('rsdk-' + window.performance.now()).replace(".", ""));
        }
        else {
            content.setAttribute(Constants.DELETE_TAG, Constants.DELETE_TAG);
        }
        content.removeAttribute(Constants.RS_IF);
        return responseHtmlString;
    };
    DomParsing.prototype.rsForHandling = function (content, model) {
        var rsForElementAttribute = content.getAttribute(Constants.RS_FOR);
        rsForElementAttribute = rsForElementAttribute ? rsForElementAttribute.replace(/#/g, '') : '';
        var loopStatement = rsForElementAttribute === null || rsForElementAttribute === void 0 ? void 0 : rsForElementAttribute.trim().split(' ');
        if (loopStatement && loopStatement.length >= 3 && loopStatement[1] === 'in') {
            var keys = loopStatement[2].split('.');
            var keyStatement = loopStatement[4];
            var lastKey = keys[keys.length - 1];
            var data = undefined;
            var replaceKey = loopStatement[2];
            if (loopStatement[2].includes("" + Constants.MODEL)) {
                data = this.getDataFromModel(loopStatement[2], model);
            }
            else {
                data = model[lastKey];
                replaceKey = Constants.MODEL + "." + loopStatement[2];
            }
            var iteratedHtml = '';
            if (data && isArray(data) && data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    iteratedHtml += content.innerHTML;
                    iteratedHtml = iteratedHtml.replace(new RegExp('#' + loopStatement[0], 'g'), replaceKey + "[" + i + "]");
                }
            }
            content.innerHTML = iteratedHtml;
        }
        else {
            content.innerHTML = ErrorConstants.RSFOR_SYNTAXT_ERROR;
            throw Error(ErrorConstants.RSFOR_SYNTAXT_ERROR);
        }
        content.removeAttribute(Constants.RS_FOR);
    };
    DomParsing.prototype.rsOfHandling = function (content, model) {
        var rsOfAttr = content.getAttribute(Constants.RS_OF);
        rsOfAttr = rsOfAttr ? rsOfAttr.replace('#', '') : '';
        var ofStatement = rsOfAttr === null || rsOfAttr === void 0 ? void 0 : rsOfAttr.trim().split(' ');
        if (ofStatement && ofStatement.length === 1) {
            var childHtml = content.innerHTML;
            childHtml = childHtml.replace(new RegExp('#' + ofStatement, 'g'), 'model');
            // childHtml = childHtml.replace(new RegExp('{rsGroupName}', 'g'), `model`);
            childHtml = childHtml.replace(new RegExp('{data-rsid}', 'g'), "model");
            childHtml = childHtml.replace(new RegExp('{rsId}', 'g'), "model");
            content.innerHTML = childHtml;
        }
        else {
            content.innerHTML = ErrorConstants.RSOF_SYNTAXT_ERROR;
            throw Error(ErrorConstants.RSOF_SYNTAXT_ERROR);
        }
        content.removeAttribute(Constants.RS_OF);
    };
    DomParsing.prototype.setRsData = function (content, model) {
        var rsDataAttribute = content.getAttribute(Constants.RS_DATA);
        if (rsDataAttribute) {
            var data = this.getDataFromModel(rsDataAttribute, model);
            if (data && typeof data === 'object' && Object.keys(data) && Object.keys(data).length) {
                for (var key in data) {
                    if (key.indexOf('data-') > -1) {
                        content.setAttribute(key, data[key]);
                    }
                }
            }
        }
        content.removeAttribute(Constants.RS_DATA);
    };
    DomParsing.prototype.deleteUnusedTags = function (content, model) {
        var _this = this;
        var elementsToDelete = content.querySelectorAll("[" + Constants.DELETE_TAG + "]");
        elementsToDelete === null || elementsToDelete === void 0 ? void 0 : elementsToDelete.forEach(function (element) {
            if (element && element.getAttribute(Constants.DELETE_TAG)) {
                element.remove();
            }
        });
        var templateToDelete = content.querySelectorAll('[rstempalteid], [data-rstempalteid]');
        templateToDelete === null || templateToDelete === void 0 ? void 0 : templateToDelete.forEach(function (element) {
            if (element && (element.getAttribute('rstempalteid') || element.getAttribute('data-rstempalteid'))) {
                if ((element.getAttribute('isinlinetemplate') || element.getAttribute('data-isinlinetemplate')) === 'true') {
                    element.innerHTML = _this.evalService.parseTpl('' + element.innerHTML, model);
                    element.rsTempalteId = _this.evalService.parseTpl('' + (element.getAttribute('rstempalteid') || element.getAttribute('data-rstempalteid')), model);
                    if (!(!element.rsTempalteId ||
                        element.rsTempalteId === 'false' ||
                        element.rsTempalteId === 'undefined' ||
                        element.rsTempalteId === 'null' ||
                        element.rsTempalteId.length === 0)) {
                        DomParsing.templatesArray['' + element.rsTempalteId] = element;
                    }
                }
                element.remove();
            }
        });
    };
    DomParsing.prototype.rsSortHandling = function (content, model) {
        var rsSortElementsAttribute = content.getAttribute(Constants.RS_SORT);
        var sortStatement = rsSortElementsAttribute === null || rsSortElementsAttribute === void 0 ? void 0 : rsSortElementsAttribute.trim().split('|');
        if (!sortStatement || sortStatement.length < 2 || sortStatement.length > 3) {
            content.innerHTML = ErrorConstants.RSSORT_SYNTAXT_ERROR;
            throw Error(ErrorConstants.RSSORT_SYNTAXT_ERROR);
        }
        else {
            var modelKey = sortStatement[0].trim();
            var modelValue = undefined;
            if (modelKey.includes("" + Constants.MODEL)) {
                modelValue = this.getDataFromModel(modelKey, model);
            }
            else {
                modelValue = model[modelKey];
            }
            var sortKey = sortStatement[1].trim();
            if (sortStatement.length === 2) {
                //SORT ASC
                this.sort(modelValue, sortKey);
            }
            else if (sortStatement.length === 3) {
                //SORT BY INPUT
                var sortType = sortStatement[2].trim();
                this.sort(modelValue, sortKey, sortType);
            }
            if (!modelKey.includes("" + Constants.MODEL)) {
                content.innerHTML = content.innerHTML.replace(new RegExp(modelKey, 'g'), Constants.MODEL + "." + modelKey);
            }
            content.innerHTML = content.innerHTML;
        }
    };
    DomParsing.prototype.sort = function (model, sortKey, sortType) {
        if (model && isArray(model) && model.length > 1 && sortKey) {
            model.sort(function (a, b) {
                return a[sortKey] > b[sortKey]
                    ? (sortType === null || sortType === void 0 ? void 0 : sortType.toUpperCase()) === Constants.SORT_DESC
                        ? -1
                        : 1
                    : (sortType === null || sortType === void 0 ? void 0 : sortType.toUpperCase()) === Constants.SORT_DESC
                        ? 1
                        : -1;
            });
        }
    };
    DomParsing.prototype.getDataFromModel = function (modelKey, model) {
        var q = modelKey.replace(Constants.MODEL + ".", '');
        var key = q.split('[').join('.').split(']').join('');
        var value = key.split('.').reduce(function (v, k) { return (v || {})[k]; }, model);
        return value;
    };
    DomParsing.prototype.returnResponse = function (htmlResponse, meessages) {
        var responseData = {
            html: htmlResponse,
            error: meessages && meessages.length > 0
                ? {
                    messages: meessages,
                    statusCode: TEMPLATE_PARSING_ISSUE,
                }
                : undefined,
        };
        return responseData;
    };
    DomParsing.templatesArray = {};
    return DomParsing;
}());
export { DomParsing };
//# sourceMappingURL=dom_parsing.js.map